var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "insect-positions-canvas",
    {
      ref: "canvas",
      attrs: {
        imageSrc: _vm.imageSrc,
        positions: _vm.pickedDetections,
        hideCanvas: _vm.hideCanvas || !_vm.imageSrc,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }